
import { CountryCodeResolver } from './../employees/services/employeeWorkExperience.resolver.service';
import { UserRoleResolver } from './../users/services/user.resolver.service';
import { UserByBusinessResolver, BusinessUserEditResolver } from './../businesses/services/business.resolver.service';
import { AdminUserEditResolver, UserListByBusinessResolver, AdminUsersListResolver } from './services/adminuser.resolver.service';
import { AdminUserService } from './services/adminuser.service';
import { AdminUserFormComponent } from './components/adminuser-form.component';
import { BusinessFeatureService } from './../businesses/services/businessFeatures.service';
import { AdminUserListComponent } from './components/adminuser-list.component';
import { AdminUserEditComponent } from './components/adminuser-edit.component';
import { AdminUserAddComponent } from './components/new-adminuser.component';
import { AdminUserRightsComponent } from './components/adminuser-rights.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSharedModule } from './../shared/appShared.module';
import { AdminUserComponent } from './adminuser.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { NgxUploaderCompatModule } from '../../_services/primeng-uploader';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { EditorModule } from 'primeng/editor';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import {PasswordModule} from 'primeng/password';
import { KubaExportModule } from '../shared/kuba-exports/kuba-export.module';
import { PasswordValidatorModule } from 'src/app/shared/password-validator/password-validator.module';


@NgModule({ exports: [
        AdminUserComponent,
        AdminUserListComponent,
        AdminUserAddComponent,
        AdminUserEditComponent,
        AdminUserFormComponent,
        AdminUserRightsComponent
    ],
    declarations: [
        AdminUserComponent,
        AdminUserListComponent,
        AdminUserAddComponent,
        AdminUserEditComponent,
        AdminUserFormComponent,
        AdminUserRightsComponent
    ],
    imports: [
        RouterModule,
        AppSharedModule,
        CommonModule,
        TranslatePipe, TranslateDirective,
        DatePickerModule,
        FormsModule,
        ReactiveFormsModule,
        EditorModule,
        ContextMenuModule,
        MenuModule,
        SelectModule,
        TableModule,
        DialogModule,
        ConfirmDialogModule,
        TextareaModule,
        InputTextModule,
        TranslatePipe, TranslateDirective,
        AppSharedModule,
        RouterModule,
        PasswordModule,
        KubaExportModule,
        PasswordValidatorModule
        
    ],
    providers: [
        AdminUserService,
        BusinessFeatureService,
        AdminUserEditResolver,
        UserByBusinessResolver,
        BusinessUserEditResolver,
        UserRoleResolver,
        UserListByBusinessResolver,
        CountryCodeResolver,
        AdminUsersListResolver,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AdminUserModule { }
